import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DirectionService } from 'src/app/core/services/direction.service';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { CommunicationService } from 'src/app/shared/communication.service';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Observable, Subject, take, takeUntil } from 'rxjs';
//import { FilterGenerique } from 'src/app/core/services/validation-demandes.service';
import { FilterGenerique } from '@models/api/requests';
import { PagedResultDTO } from '@models/shared';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { EditDirectionComponent } from './edit-direction/edit-direction.component';

@Component({
    selector: 'app-gestion-directions',
    imports: [
    DataTableOptimizedComponent,
    MatIconModule,
    ArianeNavComponent,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule
],
    templateUrl: './gestion-directions.component.html',
    styleUrls: ['./gestion-directions.component.scss']
})
export class GestionDirectionsComponent implements OnInit {
  @ViewChild('directionTable') directionTable!: DataTableOptimizedComponent;

  filterSubject = new BehaviorSubject<FilterGenerique | null>({
    filterGenerique: null
  });
  arianeLabel: string = 'Gestion des directions';
  arianeIcon: string = 'border_all';
  pipe = new DatePipe('fr-FR');
  dataTable: any[] = [];

  rowData: any = {};
  keyChanges: any = {};
  untransformedData: any = [];
  dataLength: number;
  filterValue: string = '';
  length: number;
  filterGenerique = new FormControl();
  selectedDirection: any;
  private readonly destroy$ = new Subject<void>();

  arianeList = [
    {
      label: 'Administration',
      url: '/pama/administration'
    },
    {
      label: 'Gestion des directions',
      url: '/pama/administration/gestion-directions'
    }
  ];
  constructor(
    private readonly refreshService: CommunicationService,
    public readonly dialog: MatDialog,
    private readonly detectorRef: ChangeDetectorRef,
    private readonly broadcast: Broadcast,
    private readonly excelService: ExcelService,
    private readonly directionService: DirectionService
  ) { }
  DirectionsDisplayedColumns: string[] = [
    'Libellé',
    'Structure de validation',
    'Destinataire RH recrutement',
    'Destinataire RH renouvellement',
    'Type de workflow',
    'Actions'
  ];
  demandesCellStyleCss: any = {
    //  Libellé: { 'text-align': 'center' },
    // Direction: { 'text-align': 'center' },
    // Responsable: { 'text-align': 'center' }
  };
  ngOnInit() {
    this.filterGenerique.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((value) => {
      this.filterSubject.next({
        filterGenerique: value
      });
    });
    this.loadListDirections(0, 10).subscribe();
  }

  clearFilter() {
    this.filterGenerique.setValue('');
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.filterSubject.complete();
  }
  loadListDirections = (pageIndex: number, pageSize: number, filter?: FilterGenerique): Observable<PagedResultDTO<any>> => {
    return this.directionService.getListOfDirections(pageIndex, pageSize, filter).pipe(
      map((response) => {
        this.rowData = this.transformData(response.results || []);
        this.untransformedData = response.results || [];

        this.length = response.totalRecords;
        this.detectorRef.detectChanges();
        return {
          ...response,
          results: this.transformData(response.results || response)
        };
      })
    );
  };

  transformData(result: any) {
    let data: any[] = [];

    for (let key in result) {
      let dataJ = result[key];
      let _data: any = {};
      _data['id'] = dataJ?.id;
      _data['Libellé'] = dataJ?.libelle;
      _data['Structure de validation'] = dataJ?.structValidation;
      _data['Destinataire RH recrutement'] = dataJ?.structValidationGpeec || '';
      _data['Destinataire RH renouvellement'] = dataJ?.structValidationStatutaire || '';
      _data['Type de workflow'] = dataJ?.typeWorkflow;

      if (dataJ?.typeWorkflow === 'ASSISTANT_DIRECTEUR') {
        _data['Type de workflow'] = 'Assistant vers Directeur';
      } else if (dataJ?.typeWorkflow === 'ASSISTANT_RESPONSABLE_DIRECTEUR') {
        _data['Type de workflow'] = 'Assistant vers Responsable puis Directeur';
      }

      data.push(_data);
    }
    return data;
  }
  exportOrganigramme() {
    this.directionService
      .getOrganigramme()
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          let _data_export: any[] = [];

          _data_export = this.transformOrganigrammeData(result);

          this.convertExcel(_data_export, 'export_organigramme_');
        },
        error: (error) => {
          console.log('error:', error);
          let erreur_texte = error.statusText || error.error.detail || error.error || error;

          this.dialog.open(AlerteModalComponent, {
            width: '640px',
            data: {
              title: 'Alerte',
              content: "Une erreur est survenue lors de l'export de l'organigramme.",
              status: 'STATUS: ' + error.status,
              detail: 'DETAIL: ' + erreur_texte
            }
          });
        }
      });
  }

  editDirection(direction: any) {
    if (!direction || !direction.id) {
      console.error('Direction ou ID manquant');
      return;
    }
    const directionToEdit = this.untransformedData.find((d: any) => d.id === direction.id);

    if (!directionToEdit) {
      console.error('Direction non trouvée dans untransformedData pour ID:', direction.id);
      this.dialog.open(AlerteModalComponent, {
        width: '640px',
        data: {
          title: 'Erreur',
          content: `La direction avec l'ID ${direction.id} n'a pas été trouvée.`
        }
      });
      return;
    }
    const dialogRef = this.dialog.open(EditDirectionComponent, {
      width: '780px',
      disableClose: true,
      data: {
        edition: true,
        id: directionToEdit.id,
        libelle: directionToEdit.libelle,
        structValidation: directionToEdit.structValidation,
        typeWorkflow: directionToEdit.typeWorkflow,
        structValidationGpeec: directionToEdit.structValidationGpeec,
        structValidationStatutaire: directionToEdit.structValidationStatutaire
      }
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          this.directionTable?.refresh();
          this.detectorRef.detectChanges();
        }
      });
  }

  searchDataID(data: any[], id: string) {
    const found = data.find((d) => d.id === id);
    if (found) {
      this.rowData = found;
    } else {
      console.error("Direction non trouvée pour l'id", id);
    }
  }

  transformOrganigrammeData(dir_list: any) {
    let dataCSV: any[] = [];

    if (dir_list) {
      for (let key in dir_list) {
        let dataRow = dir_list[key];

        let isWorkflowResponsable = dataRow?.workflowResponsable == true;

        if (isWorkflowResponsable) {
          let serv_list = dataRow?.services;
          for (let keyService in serv_list) {
            let dataRowService = serv_list[keyService];

            let ligne: any = {};

            ligne['Direction'] = dataRow?.libelleDirection;
            ligne['Service'] = dataRowService?.libelleService;
            ligne['Total agents'] = dataRowService?.nbAgentsTotal;
            ligne['Total actifs'] = dataRowService?.nbAgentsActifs;
            ligne['Total inactifs'] = dataRowService?.nbAgentsInactifs;
            ligne['Responsable'] = dataRowService?.nomResponsable;
            ligne['Directeur(s)'] = dataRow?.directeurs?.map((dir: any) => dir.nomDirecteur).join(', \n');
            ligne['DG(s)'] = dataRow?.dgs?.map((dir: any) => dir.nomDirecteur).join(', \n');
            ligne['Responsable délégué'] = dataRowService?.delegues?.map((dir: any) => dir.nomDelegue).join(', \n');
            ligne['Directeur(s) délégué(s)'] = dataRow?.directeurs
              ?.map((dir: any) => dir.delegues?.map((del: any) => del.nomDelegue).join(', \n'))
              .join(' \n');
            ligne['DG(s) délégué(s)'] = dataRow?.dgs
              ?.map((dir: any) => dir.delegues?.map((del: any) => del.nomDelegue).join(', \n'))
              .join(' \n');

            let commentaireParam = '';
            if (dataRowService?.responsableNonFonctionnel) {
              commentaireParam += dataRowService?.commentaireNonFonctionnel + ', \n';
            }
            for (let delegResp in dataRowService?.delegues) {
              let delegRow = dataRowService?.delegues[delegResp];
              if (delegRow.delegationExpire) {
                commentaireParam += 'Délégation responsable expirée, \n';
              }
              if (delegRow.delegationNonFonctionnelle) {
                commentaireParam += delegRow?.commentaireNonFonctionnelle + ', \n';
              }
            }
            for (let dir in dataRow?.directeurs) {
              let delegDir = dataRow?.directeurs[dir];
              for (let deleg in delegDir?.delegues) {
                let delegRow = delegDir?.delegues[deleg];
                if (delegRow.delegationExpire) {
                  commentaireParam += 'Délégation directeur expirée, \n';
                }
                if (delegRow.delegationNonFonctionnelle) {
                  commentaireParam += delegRow?.commentaireNonFonctionnelle + ', \n';
                }
              }
            }
            for (let dir in dataRow?.dgs) {
              let delegDir = dataRow?.dgs[dir];
              for (let deleg in delegDir?.delegues) {
                let delegRow = delegDir?.delegues[deleg];
                if (delegRow.delegationExpire) {
                  commentaireParam += 'Délégation DG expirée, \n';
                }
                if (delegRow.delegationNonFonctionnelle) {
                  commentaireParam += delegRow?.commentaireNonFonctionnelle + ', \n';
                }
              }
            }

            ligne['Commentaires paramétrage'] = commentaireParam;

            dataCSV.push(ligne);
          }
        } else {
          let ligne: any = {};

          ligne['Direction'] = dataRow?.libelleDirection;
          ligne['Service'] = '';
          ligne['Total agents'] = dataRow?.nbAgentsTotal;
          ligne['Total actifs'] = dataRow?.nbAgentsActifs;
          ligne['Total inactifs'] = dataRow?.nbAgentsInactifs;
          ligne['Responsable'] = '';
          ligne['Directeur(s)'] = dataRow?.directeurs?.map((dir: any) => dir.nomDirecteur).join(', \n');
          ligne['DG(s)'] = dataRow?.dgs?.map((dir: any) => dir.nomDirecteur).join(', \n');
          ligne['Responsable délégué'] = '';
          ligne['Directeur(s) délégué(s)'] = dataRow?.directeurs
            ?.map((dir: any) => dir.delegues?.map((del: any) => del.nomDelegue).join(', \n'))
            .join(', \n');
          ligne['DG(s) délégué(s)'] = dataRow?.dgs
            ?.map((dir: any) => dir.delegues?.map((del: any) => del.nomDelegue).join(', \n'))
            .join(' \n');

          let commentaireParam = '';

          for (let dir in dataRow?.directeurs) {
            let delegDir = dataRow?.directeurs[dir];
            for (let deleg in delegDir?.delegues) {
              let delegRow = delegDir?.delegues[deleg];
              if (delegRow.delegationExpire) {
                commentaireParam += 'Délégation directeur expirée, \n';
              }
              if (delegRow.delegationNonFonctionnelle) {
                commentaireParam += delegRow?.commentaireNonFonctionnelle + ', \n';
              }
            }
          }
          for (let dir in dataRow?.dgs) {
            let delegDir = dataRow?.dgs[dir];
            for (let deleg in delegDir?.delegues) {
              let delegRow = delegDir?.delegues[deleg];
              if (delegRow.delegationExpire) {
                commentaireParam += 'Délégation DG expirée, \n';
              }
              if (delegRow.delegationNonFonctionnelle) {
                commentaireParam += delegRow?.commentaireNonFonctionnelle + ', \n';
              }
            }
          }

          ligne['Commentaires paramétrage'] = commentaireParam;

          dataCSV.push(ligne);
        }
      }
    }

    return dataCSV;
  }

  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }

}
